export const EMAIL_TEMPLATE_TOOLBAR_OPTIONS = [
  ["font", "fontSize", "formatBlock"],
  ["bold", "italic", "underline", "strike", "subscript", "superscript"],
  ["fontColor", "hiliteColor"],
  ["removeFormat"],
  ["paragraphStyle"],
  ["align", "list", "horizontalRule", "lineHeight"],
  ["outdent", "indent"],
  ["image", "video", "blockquote", "codeView"],
  ["table", "link"],
  ["undo", "redo"],
];

export const getEmailTemplateSunEditorOptions = ({ height }) => ({
  buttonList: EMAIL_TEMPLATE_TOOLBAR_OPTIONS,
  height,
  attributesWhitelist: {
    all: "class|style|data-.+",
  },
  align: "left|center|right",
  imageFileInput: false,
});

export const createBlockLocalImageUploadBefore = ({ t, Toast }) => {
  return () => {
    Toast({
      type: "warning",
      title: t("settings:email_template_editor"),
      message: t("settings:email_image_url_only"),
    });
    return false;
  };
};

const showLocalImageBlockedToast = ({ t, Toast }) => {
  Toast({
    type: "warning",
    title: t("settings:email_template_editor"),
    message: t("settings:email_image_url_only"),
  });
};

export const attachLocalImagePasteDropGuard = (rootElement, { t, Toast }) => {
  const editable = rootElement?.querySelector(".sun-editor-editable");
  if (!editable) {
    return () => {};
  }

  const handlePaste = (event) => {
    const items = event.clipboardData?.items;
    if (!items) return;

    for (const item of items) {
      if (item.type?.startsWith("image/")) {
        event.preventDefault();
        showLocalImageBlockedToast({ t, Toast });
        return;
      }
    }
  };

  const handleDrop = (event) => {
    const files = event.dataTransfer?.files;
    if (!files?.length) return;

    for (const file of files) {
      if (file.type?.startsWith("image/")) {
        event.preventDefault();
        showLocalImageBlockedToast({ t, Toast });
        return;
      }
    }
  };

  editable.addEventListener("paste", handlePaste);
  editable.addEventListener("drop", handleDrop);

  return () => {
    editable.removeEventListener("paste", handlePaste);
    editable.removeEventListener("drop", handleDrop);
  };
};
